export default __webpack_public_path__ + "static/media/chungus-bold-fat.a0cc6455.png";